import React, {Component} from "react";

import * as componentTypes from "../constants/componentTypes";
import * as windowService from "../services/windowService";
import * as styles from "../constants/styles";
import * as rcc from "../constants/rcc";

import Router from "./Router";
import Welcome from "./scenes/Welcome";
import ScreenSaver from "./global/ScreenSaver";
import FlashMessage from "./global/FlashMessage";
import BarcodeScanner from "./global/BarcodeScanner";
import Modal from "./global/Modal";

export default class App extends Component {
    getMainClassName = (scaleFactor) => {
        let mainClass = this.props.softwareStyle + " " + this.props.customStyle;

        if (this.props.blocked) {
            mainClass += " blocked-ui";
        }

        if (this.props.activeMenu) {
            mainClass += " left-panel-open";
        }

        if (this.props.setupSoftware) {
            mainClass += " setup-software";
        }

        if (scaleFactor !== 1) {
            mainClass += " scale-" + scaleFactor * 100;
        }

        if (
            this.props.zoom > 0 &&
            this.props.rendered &&
            this.props.initialized &&
            this.props.applicationStatus === componentTypes.APPLICATION_STATUS_RUNNING
        ) {
            mainClass += " zoom-" + this.props.zoom;
        }

        if (this.props.activeDialog !== null) {
            mainClass += " rcc-panel-open";
            if (this.props.activeDialog === componentTypes.RCC_SPECTRO_DIALOG) {
                mainClass += " spectro-panel-open";

                if (this.props.spectroDialogMessage === rcc.RCC_MESSAGE_MEASURE_SELECT_MEASURE_MODE) {
                    mainClass += " modal-open";
                }
            }
        }

        mainClass += this.props.keyBoard ? " keyboard-open" : " keyboard-close";

        if (
            (this.props.machineDialogType === componentTypes.MACHINE_DIALOG_ERROR &&
                window.imageStore.getMachineError() !== null) ||
            this.props.machineDialogType === componentTypes.MACHINE_DIALOG_REFILL
        ) {
            mainClass += " error-image-open";
        }

        if (this.props.activeNotificationPanel) {
            mainClass += " notification-panel-open";
        }

        if (this.props.plugins.winter) {
            mainClass += " " + styles.WINTER_STYLE;
        }

        if (this.props.manualScan) {
            return mainClass + " modal-open";
        }

        if (this.props.activeModal === 0) {
            return mainClass;
        }

        if (this.props.modalList.some((modal) => modal.style === componentTypes.MODAL_SETTINGS_STYLE)) {
            return mainClass + " settings-modal-open";
        }

        if (this.props.modalList.some((modal) => modal.style === componentTypes.MODAL_BLANK_STYLE)) {
            return mainClass;
        }

        return mainClass + " modal-open";
    };

    getMainContent = () => {
        if (
            this.props.connected === true &&
            this.props.initialized &&
            this.props.applicationStatus === componentTypes.APPLICATION_STATUS_RUNNING
        ) {
            return <Router />;
        }

        return <Welcome />;
    };

    getFlashMessages = () => {
        let flashMessages = [];

        let message;
        for (message of this.props.flashMessages) {
            let key = this.props.flashMessages.indexOf(message);
            flashMessages.push(
                <div className="flash-message-magic" key={key} style={{WebkitAppRegion: "no-drag"}}>
                    <FlashMessage index={key} type={message.type} text={message.text} />
                    <div className="flash-mesage-space" />
                </div>
            );
        }

        return flashMessages;
    };

    handleBackgroundClick = () => {
        this.props.backgroundClick();
    };

    renderModals = () => {
        if (this.props.activeModal === 0 || !this.props.initialized) {
            return [];
        }

        let modals = [];
        this.props.modalList.forEach((modal) => {
            modals.push(
                <Modal key={modal.id} id={modal.id} type={modal.type} tabId={modal.tabId} params={modal.params} />
            );
        });

        return modals;
    };

    getMain = () => {
        return (
            <React.Fragment>
                {this.getMainContent()}
                <div className="flash-messages-box">{this.getFlashMessages()}</div>
                <div className="background-shadow" onClick={this.handleBackgroundClick} />
                <BarcodeScanner />
                <ScreenSaver />
                {this.renderModals()}
            </React.Fragment>
        );
    };

    render() {
        let params = windowService.getParams();

        if (params !== null && params.scaleFactor !== 1 && params.screenWidth * params.scaleFactor <= 1600) {
            let windowZoom = 1 / params.scaleFactor;
            return (
                <div id="main" className={this.getMainClassName(params.scaleFactor)} style={{zoom: windowZoom}}>
                    {this.getMain()}
                </div>
            );
        }

        return (
            <div id="main" className={this.getMainClassName(1)}>
                {this.getMain()}
            </div>
        );
    }
}
